import { makeStyles } from "@mui/styles";

export const useLinkWithIconStyles = makeStyles({
    root: {
        fontWeight: "bold",
        display: "inline-block",
    },
    content: {
        display: "flex",
        alignItems: "center",
    },
});
